import { render, staticRenderFns } from "./PublicationEdit.vue?vue&type=template&id=182cae64&scoped=true&"
import script from "./PublicationEdit.vue?vue&type=script&lang=js&"
export * from "./PublicationEdit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "182cae64",
  null
  
)

export default component.exports